<unity-page-container [contentHeader]="$contentHeader()" [isLoading]="false">
  @let formGroup = $formGroup();
  <unity-card-new-shared actionName="Assign" [formGroup]="formGroup" [formLoading]="$formLoading()" (submitEvent)="onSubmit()">
    @let user = userResource.value();
    @if (user) {
      <unity-textbox-readonly-control displayName="User" [value]="user.full_name" />
    }
    <unity-dropdown-agency-control
      displayName="Business Partner"
      description="Select the business partner to which the user should be assigned."
      [control]="formGroup.controls.agency_id"
      (selectionChangeEvent)="agencyHandler($event)" />
    @let inputRoles = $inputRoles();
    @if (inputRoles) {
      <unity-dropdown-control
        displayName="Role"
        description="Select the user's role at this business partner."
        [values]="inputRoles"
        [control]="formGroup.controls.role_id" />
    }
  </unity-card-new-shared>
</unity-page-container>
